import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJfrogComponent } from './simple-icons-jfrog.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJfrogComponent ],
    exports:      [ SimpleIconsJfrogComponent ],
    bootstrap:    []
})
export class SimpleIconsJfrogModule {}
